import React from 'react';

const RemoveFromCartButton = () => {
  return (
    <svg viewBox="0 0 390 390">
      <g>
        <g>
          <path
            d="M161.319,322.763c-17.201,0-31.136,13.934-31.136,31.12c0,17.189,13.935,31.124,31.136,31.124   c17.184,0,31.121-13.935,31.121-31.124C192.44,336.696,178.503,322.763,161.319,322.763z"
            data-original="#000000"
            className="active-path"
            data-old_color="#000000"
          />
          <path
            d="M275.685,322.763c-17.193,0-31.13,13.934-31.13,31.12c0,17.189,13.937,31.124,31.13,31.124   c17.192,0,31.118-13.935,31.118-31.124C306.803,336.696,292.877,322.763,275.685,322.763z"
            data-original="#000000"
            className="active-path"
            data-old_color="#000000"
          />
          <path
            d="M387.262,112.516c-2.899-4.223-7.699-6.751-12.833-6.751h-53.464c-1.198-4.189-3.082-8.227-5.667-11.932l-50.037-71.728   c-7.477-10.716-19.74-17.113-32.806-17.113c-13.066,0-25.33,6.397-32.807,17.114l-50.037,71.727   c-2.584,3.705-4.469,7.741-5.667,11.931H96.162L80.165,64.914c-2.079-5.293-5.805-9.769-10.633-12.759L40.111,33.933   C27.782,26.295,11.58,30.097,3.94,42.436C-3.699,54.773,0.107,70.97,12.442,78.61l21.976,13.611l75.851,196.541   c2.313,6.012,8.092,9.975,14.532,9.975h187.39c6.44,0,12.22-3.963,14.527-9.975l62.246-161.852   C390.803,122.129,390.168,116.742,387.262,112.516z M295.871,123.657c-2.585,4.955-7.71,8.062-13.299,8.062h-21.036v62.143   c0,8.284-6.716,15-15,15h-28c-8.284,0-15-6.716-15-15v-62.144H182.5c-5.589,0-10.714-3.107-13.299-8.063   c-2.585-4.955-2.201-10.936,0.996-15.52l50.036-71.726c2.806-4.021,7.399-6.418,12.303-6.418c4.903,0,9.497,2.396,12.303,6.418   l50.036,71.727C298.072,112.722,298.456,118.702,295.871,123.657z"
            data-original="#000000"
            className="active-path"
            data-old_color="#000000"
          />
        </g>
      </g>
    </svg>
  );
};

export default RemoveFromCartButton;
